<template>
  <modal title="Confirmation" size="xs" ref="modal">
    <h2 class="text-subtitle1">
      Deleting a client deletes all data associated with the client, including their posts.
    </h2>
    <h2 class="text-subtitle1">
      Are you sure you want to delete <strong>{{ clientName }}</strong>?
    </h2>
    <template v-slot:actions>
      <async-btn :task="task" label="Delete" color="negative" @click="deleteClient" />
    </template>
  </modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ModalMixin } from '@/mixins';
import AsyncBtn from '@/components/AsyncBtn.vue';
import { Client, Modal as ModalElement } from '@/type';
import notify from '@/components/notify';
import Modal from '@/components/modal/Modal.vue';
import { deleteClient } from './client';
import { name as clientName } from './client-filter';

  interface Data {
    task: Promise<void>|null
  }

export default defineComponent({
  emits: ['ok'],
  mixins: [ModalMixin],
  components: {
    Modal,
    AsyncBtn,
  },
  props: {
    client: {
      type: Object as () => Client,
      required: true,
    },
  },
  data(): Data {
    return {
      task: null,
    };
  },
  computed: {
    clientName(): string {
      return clientName(this.client);
    },
  },
  methods: {
    deleteClient() {
      this.task = deleteClient(this.client.id);
      this.task.then(() => {
        this.$emit('ok', this.client);
        notify(`${this.clientName} was deleted.`);
        (this.$refs.modal as ModalElement).hide();
      });
    },
  },
});
</script>
